import APIConnector from "../lib/APIConnector";

import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class StatsConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointStats() {
    return `${StatsConfig.endpoint}/stats`;
  }
  static get endpointOrdersStats() {
    return `${StatsConfig.endpointStats}/orders`;
  }
  static get endpointMenuStats() {
    return `${StatsConfig.endpointStats}/menu`;
  }
  static get endpointTopClientStats() {
    return `${StatsConfig.endpointStats}/top`;
  }
  static get endpointLiqResumeStats() {
    return `${StatsConfig.endpointStats}/liqresume`;
  }
  static get endpointLiqDetailStats() {
    return `${StatsConfig.endpointStats}/liqdetail`;
  }
  static get APIConnector() {
    return apiConnector
  }

}



// WEBPACK FOOTER //
// ./src/provider/statistics/StatsConfig.js